import {
  Button,
  ButtonSize,
  ButtonStyles,
  Theme,
  useTranslation,
  useBreakpoint,
  Breakpoints,
  ButtonWidth,
  useNextgenRouter,
} from '@nextgen-web-framework/all';
import { ConfigService, Logger } from '@nextgen-web-framework/core';
import { ErrorCard, Errors } from '@commerce-webcomponents/ui';
import { memo } from 'react';
import type { RegistrationErrorCardProps } from './types/propsTypes';
import styles from './RegistrationErrorCard.module.scss';

export const RegistrationErrorCard = ({
  primaryRedirectUrl,
  primaryButtonLabel,
  desc,
  title,
}: RegistrationErrorCardProps) => {
  const viewport = useBreakpoint() as Breakpoints;
  const buttonSize = [Breakpoints.MD].includes(viewport) ? ButtonSize.SMALL : ButtonSize.MEDIUM;
  const configs = ConfigService.getConfigs();
  const assetsBasePath = configs.NEXT_ASSETS_BASE_PATH as string;
  const t = useTranslation();
  const router = useNextgenRouter();
  const logger = Logger.getInstance();

  const onPrimaryButtonClick = () => {
    if (primaryRedirectUrl) {
      logger.log('redirect to ', primaryRedirectUrl);
      router.push(primaryRedirectUrl);
    }
  };

  return (
    <ErrorCard
      title={title ? t(title) : ''}
      description={t(desc ?? 'profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle')}
      imageUrl={`${assetsBasePath}/images/Error.png`}
      type={Errors.General}
      className={styles['error-card']}
      customCtaComponent={
        <div className={styles['error-card-button']}>
          <Button
            buttonStyle={ButtonStyles.SOLID}
            onClick={onPrimaryButtonClick}
            size={buttonSize}
            theme={Theme.BLACK}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            title={primaryButtonLabel ? t(primaryButtonLabel) : ''}
            type="button"
            data-testId="home-btn"
          />
        </div>
      }
    />
  );
};

export default memo(RegistrationErrorCard);
